// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { Button, Paper, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material'
import cn from 'classnames'
import get from 'lodash/get'
import React from 'react'
import withConfirmModal from '../../../common/confirmModal/withConfirmModal'
import { getConnectionNodes } from '../../../common/data/helper'
import { alphaSort } from '../../../common/utils'
import taskSectionCss from '../../checklist/ChecklistTaskSection.css'
import panelCss from '../../employeeCard/incentivesPanel/IncentivesPanel.css'
import { i18n } from '../../index'
import ChecklistRow from './ChecklistRow'
import ContinuingChecklistRow from './ContinuingChecklistRow'
import css from './checklistTable.css'
import type { ChecklistItem } from './checklistTypes'
import { checklistItemDays, checklistItemTypes } from './constants'
type Props = {
  data: Array<ChecklistItem>
  onEdit: (...args: Array<any>) => any
  stationId: string
  confirmModal: {
    show: (...args: Array<any>) => any
  }
  refetch: (...args: Array<any>) => any
}

class ChecklistTable extends React.Component<Props> {
  state = {
    filterTypes: {},
    filterDays: {},
  }
  onDelete = (onMutate: (...args: Array<any>) => any, id: string) => {
    const { refetch } = this.props
    this.props.confirmModal.show(i18n.t('admin.checklists.deleteConfirmationText'), async (isConfirmed: boolean) => {
      if (isConfirmed) {
        await onMutate({
          variables: {
            id,
          },
        })
        refetch()
      }
    })
  }
  setTypeFilter = (type: string | null) => () => {
    const exists = this.state.filterTypes[type]
    const newState = { ...this.state.filterTypes }

    if (exists) {
      delete newState[type]
    } else {
      newState[type] = true
    }

    this.setState({
      filterTypes: newState,
    })
  }
  setDayFilter = (day: string) => () => {
    const exists = this.state.filterDays[day]
    const newState = { ...this.state.filterDays }

    if (exists) {
      delete newState[day]
    } else {
      const everyDayChosen = day === 'Everyday'

      if (everyDayChosen) {
        return !!this.setState({
          filterDays: {
            [day]: true,
          },
        })
      }

      delete newState.Everyday
      newState[day] = true
    }

    this.setState({
      filterDays: newState,
    })
  }

  render() {
    const { data, stationId, onEdit } = this.props
    const checklistItems = stationId
      ? getConnectionNodes(get(data, 'stationChecklistsItems'))
      : getConnectionNodes(get(data, 'checklistItems'))
    const continuingChecklistItems = get(data, 'continuingChecklistItems')
    const { filterTypes, filterDays } = this.state
    const filteredItems = checklistItems.filter((item) => {
      const typeFilters = Object.keys(filterTypes)
      const dayFilters = Object.keys(filterDays)
      // item.type = item.type ? item.type : []
      const typeCheck =
        typeFilters.length === 0 ? true : item.type && typeFilters.some((filter) => item.type.includes(filter))

      if (dayFilters.length !== 0) {
        const taskDayCount = item.days.length

        // Task has day assigned
        if (taskDayCount !== 0) {
          // If filtered by everyday only list tasks with all days selected.
          if (dayFilters.includes('Everyday')) {
            return typeCheck && taskDayCount === 7
          }

          // If not everyday: show all tasks that have specific day listed
          if (taskDayCount < 7) {
            const dayCheck = dayFilters.some((r) => item.days.includes(r))
            return typeCheck && dayCheck
          }

          // If no days match and Everyday isn't chosen: return false
          return false
        }
      }

      return typeCheck
    })
    return (
      <div>
        <Paper>
          <div className={cn(css.component, panelCss.checkListContainer)}>
            <div>
              <div className={taskSectionCss.filterContainer}>
                <p className={taskSectionCss.filterHeading}>{i18n.t('checkList.filterByType')}:</p>

                {checklistItemTypes.map((type) => {
                  return (
                    <Button
                      className={cn(taskSectionCss.button, {
                        [taskSectionCss.selected]: filterTypes[type],
                      })}
                      key={type}
                      color={filterTypes[type] ? 'primary' : 'secondary'}
                      onClick={this.setTypeFilter(type)}
                    >
                      {i18n.t(`checkList.type.${type}`)}
                    </Button>
                  )
                })}
                <Button
                  className={cn(taskSectionCss.button, {
                    [taskSectionCss.selected]: filterTypes[null],
                  })}
                  color={filterTypes[null] ? 'primary' : 'secondary'}
                  onClick={this.setTypeFilter(null)}
                >
                  {i18n.t(`checkList.type.NotDefined`)}
                </Button>
              </div>
              <div className={css.dayFilterContainer}>
                {checklistItemDays.map((day) => {
                  return (
                    <Button
                      className={cn(taskSectionCss.button, {
                        [taskSectionCss.selected]: filterDays[day],
                      })}
                      key={day}
                      color={filterDays[day] ? 'primary' : 'secondary'}
                      onClick={this.setDayFilter(day)}
                    >
                      {i18n.t(`checkList.days.${day}`)}
                    </Button>
                  )
                })}
              </div>
            </div>
            {checklistItems.length ? (
              <Table size='medium'>
                <TableHead>
                  <TableRow>
                    <TableCell className={cn(css.tableHeading, css.descriptionCell)}>
                      {i18n.t('admin.checklists.label.description')}
                    </TableCell>
                    <TableCell className={css.tableHeading}>{i18n.t('admin.checklists.label.weekDays')}</TableCell>
                    <TableCell className={css.tableHeading} padding='checkbox'>
                      {i18n.t('admin.checklists.label.shiftStatus.morning')}
                    </TableCell>
                    <TableCell className={css.tableHeading} padding='checkbox'>
                      {i18n.t('admin.checklists.label.shiftStatus.evening')}
                    </TableCell>
                    <TableCell className={css.tableHeading} padding='checkbox'>
                      {i18n.t('admin.checklists.label.shiftStatus.night')}
                    </TableCell>
                    <TableCell className={css.tableHeading} />
                  </TableRow>
                </TableHead>
                <TableBody>
                  {alphaSort('description', filteredItems).map((checklistItem, i) => (
                    <ChecklistRow
                      data={checklistItem}
                      stationId={stationId}
                      onEdit={onEdit}
                      onDelete={this.onDelete}
                      key={i}
                    />
                  ))}
                </TableBody>
              </Table>
            ) : (
              <p className={css.empty}>{i18n.t('admin.checklists.noChecklists')}</p>
            )}
          </div>
        </Paper>

        {continuingChecklistItems && continuingChecklistItems.length > 0 && (
          <React.Fragment>
            <Paper>
              <div className={css.component}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell className={cn(css.tableHeading, css.descriptionCell)}>
                        {i18n.t('admin.checklists.label.description')}
                      </TableCell>
                      <TableCell className={css.tableHeading}>{i18n.t('admin.checklists.label.type')}</TableCell>
                      <TableCell className={css.tableHeading} padding='checkbox'>
                        {i18n.t('admin.checklists.label.continuingChecklist.monthly')}
                      </TableCell>
                      <TableCell className={css.tableHeading} padding='checkbox'>
                        {i18n.t('admin.checklists.label.continuingChecklist.weekly')}
                      </TableCell>
                      <TableCell className={css.tableHeading} padding='checkbox'>
                        {i18n.t('admin.checklists.label.continuingChecklist.daily')}
                      </TableCell>
                      <TableCell className={css.tableHeading} />
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {alphaSort('description', continuingChecklistItems).map((item, i) => (
                      <ContinuingChecklistRow key={i} data={item} onEdit={onEdit} onDelete={this.onDelete} />
                    ))}
                  </TableBody>
                </Table>
              </div>
            </Paper>
          </React.Fragment>
        )}
      </div>
    )
  }
}

export default withConfirmModal(ChecklistTable)
